// Frontend mirror of the backend's brand → model number list, used to
// drive the model-number Autocomplete in BrandModelSearch.
//
// Source of truth: sipp_express/src/services/wqi/engine/config/earthsmartFilterMap.ts
// 9 brands, 150 models. Kept as a plain string lookup (no filter codes) —
// the backend still owns the match/normalization. When the backend map
// changes, mirror the new model keys here.
//
// Keep Earthsmart out of any user-facing copy — this is purely the data
// the picker needs to suggest known models. Brand keys match the
// EARTHSMART_BRANDS list used elsewhere in the frontend.

export const FILTER_MODELS: Record<string, string[]> = {
  Samsung: [
    'RF267AERS',
    'RF268ABRS',
    'RFG237AARS',
    'RFG293HABP',
    'RFG297AARS',
    'RH22H9010SG',
    'RH22H9010SR',
    'RH25H5611SR',
    'RH29H9000SR',
    'RS22HDHPNSR',
    'RS22HDHPNWW',
    'RS25H5111SG',
    'RS25H5111SR',
    'RS25J500DBC',
    'RS25J500DSG',
    'RS25J500DSR',
    'RS25J500DWW',
    'RS263TDWP',
    'RS265TDBP',
    'RS267TDRS',
    'RS267TDWP',
    'RSG257AARS',
    'RF220NCTASG',
    'RF22K9381SG',
    'RF22K9381SR',
    'RF23HCEDBSR',
    'RF23HTEDBSR',
    'RF23J9011SG',
    'RF23J9011SR',
    'RF25HMEDBSR',
    'RF260BEAESR',
    'RF261BEAESR',
    'RF263BEAESR',
    'RF26J7500SR',
    'RF28HMEDBSR',
    'RF28HFEDBSR',
    'RF28K9380SG',
    'RF28K9380SR',
    'RF30KMEDBSR',
    'RF18A5101SG',
    'RF18A5101SR',
    'RF20A5101SG',
    'RF20A5101SR',
    'RF22A4221SR',
    'RF23A9071SG',
    'RF23A9071SR',
    'RF23A9671SG',
    'RF23A9671SR',
    'RF23BB8200AP',
    'RF23BB8600AP',
    'RF23DB9600QL',
    'RF24BB6200AP',
    'RF25C5551SR',
    'RF26CG7400SR',
    'RF27CG5010SR',
    'RF27CG5400SR',
    'RF28R6201SG',
    'RF28R7201SR',
    'RF29A9071SG',
    'RF29A9671SG',
    'RF29BB8200AP',
    'RF29DB9600QL',
    'RF30BB6200AP',
    'RF31CG5100SR',
    'RF32CG5400SR',
    'RS22T5201SG',
    'RS27T5200SR',
    'RS28A500ASR',
  ],
  LG: [
    'LFX25778SB',
    'LFX25778ST',
    'LFX25778SW',
    'LRSC21934SB',
    'LRSC21934SW',
    'LFX25973D',
    'LFX25973ST',
    'LFX25974ST',
    'LMX25964SS',
    'LFD20786SB',
    'LFXS24623S',
    'LFXS30766S',
    'LFXC24766S',
    'LMXS30776S',
    'LNXC23726',
    'LNXS30866',
    'LFCC22426S',
    'LFXS26973S',
    'LMWC23626S',
    'LMXS28626S',
    'LRFDS3016S',
    'LRMXS2806S',
  ],
  Frigidaire: [
    '25352622200',
    '25352623200',
    '25352624200',
    'FRS23H5ASB',
    'FRS26R3A',
    'GLHT188WHW3',
    'FFHB2750TD0',
    'FFHB2750TS0',
    'FGHB2868TF',
    'FGSC2335TF',
    'FPBC2277RF0',
    'FPBS2777RF0',
    'FRSS2323AS',
    'GRFN2023AF',
    'PRFC2383AF',
  ],
  GE: [
    'BSS25JFRJWW',
    'DSE25JSHBCSS',
    'DSS25KGREBB',
    'GFSS6KKYCSS',
    'GTH22SHPARBS',
    'GTS18KHPARBB',
    'PDS20MCP',
    'PFCS1NJWSS',
    'CFE28TSHSS',
    'CWE23SSHSS',
    'CFE28TSH',
    'GFE26JSMSS',
    'GFE28GYNFS',
    'GSS25GYPBCFS',
    'PYE22KSKSS',
  ],
  Maytag: [
    'AS229CSBGB',
    'AS229FBBGB',
    'MZD2766GEB',
    'MZD2766GES',
  ],
  Whirlpool: [
    'ED5FHEXNS00',
    'ED5GTGXNQ00',
    'ED5GTGXNS00',
    'ED5JHAXTS00',
    'GC5SHGXLS00',
    'KSCS25FKSS02',
    'CS22AEXHN00',
    'ED22PEXHB00',
    'ED25QFXHB00',
    'ED27QFXHB00',
    '4396841',
    'ET1FHTXMQ01',
  ],
  'Sears/Kenmore': [
    '10655512400',
    '469991',
    '25370313',
    '25370413',
  ],
  Amana: [
    'ABB1924BRM',
    'ABB2224BRM',
    'AFD2535DEB',
    'ART104TFDB',
    'ASI2175GRB',
    'ASI2575FRB',
    'WF50',
  ],
  KitchenAid: [
    'KSCS25FKSS01',
    'KSRA25CNSS00',
    'KTRP22EMSS01',
  ],
}
